<template>
	<div class="cargoissue" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<el-card class="box-card">
			<el-steps :active="active" finish-status="success" simple>
				<el-step title="Select product group"></el-step>
				<el-step title="Product details"></el-step>
				<el-step title="Product description"></el-step>
			</el-steps>
		</el-card>
		<el-card class="box-card" style="margin-top:10px" v-show="active == 0">
			<el-row>
				<el-col :span="3">
					<span>Product language</span>
				</el-col>
				<el-col :span="21">
					<el-select size="mini" @change="changelang" v-model="cargoinfo.lang" placeholder="" style="width:200px">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in langlist" :key="index"></el-option>
					</el-select>
				</el-col>
			</el-row>
			<el-row style="margin-top:10px">
				<el-col :span="24">
					<el-cascader-panel
						ref="sortpanel"
						:options="sortlist"
						:value="cargoinfo.p_sort"
						:props="props"
						@expand-change="selectchange"
						:emitPath="true"
					></el-cascader-panel>
				</el-col>
			</el-row>
			<el-row style="margin-top:10px">
				<el-col :span="24" style="padding-left:10px">Group choosen is：
					<span>{{selectedsort}}</span>
				</el-col>
			</el-row>
		</el-card>
		<div style="margin-top:10px" v-show="active == 1">
			<el-card class="box-card" v-loading="cargoinfoloading">
				<div slot="header" class="clearfix"><span>Basic details</span></div>
				<el-row>
					<el-col :span="8">
						<el-form label-width="150px" size="mini">
							<el-form-item label="Product Group">
								<span>{{selectedsort}}</span>
							</el-form-item>
							<el-form-item label="Product ID"><el-input v-model="cargoinfo.pkcno" :readonly="cargo_id!=''"></el-input></el-form-item>
							<el-form-item label="Product name"><el-input v-model="cargoinfo.cname"></el-input></el-form-item>
							<el-form-item label="Product brand">
								<el-select v-model="cargoinfo.brand" placeholder="" style="width:100%">
									<el-option :label="item.label" :value="item.label" v-for="(item, index) in brandlist" :key="index"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="Product full name"><el-input v-model="cargoinfo.cnameall"></el-input></el-form-item>
						</el-form>
					</el-col>
				</el-row>
			</el-card>
			<el-card class="box-card">
				<div slot="header" class="clearfix"><span>Product specs</span></div>
				<el-row>
					<el-col :span="16">
						<el-form label-width="100px" size="mini" class="specform">
							<el-form-item :label="item.spec_name" v-for="(item, index) in speclist" :key="index">
								<el-tag :effect="s.selected ? 'dark' : 'plain'" v-for="(s, i) in item.spec" :key="i" @click="Specselect(index, i)">{{ s.value }}</el-tag>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="8"></el-col>
				</el-row>
				<tableui
					v-if="specdatalist.length > 0"
					style="width:100%;"
					v-loading="loading"
					ref="speclist"
					editcell="0"
					:tableData="specdatalist"
					:columns="spectablecol"
					:gridheight="gridheight"
				></tableui>
			</el-card>
			<el-card class="box-card" v-loading="picloading">
				<div slot="header" class="clearfix"><span>Pictures</span></div>
				<el-row>
					<el-col :span="12">
						<el-form label-width="100px" size="mini">
							<el-form-item label="Product pic">
								<el-upload
									class="avatar-uploader"
									action="#"
									:show-file-list="false"
									:on-change="searchPicChange"
									:limit="1"
									accept="image/*"
									ref="upload"
									v-model="cargoinfo.search_pic"
									style="padding-left:10px"
								>
									<i class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="10">
						<el-carousel arrow="nerver" height="215px" indicator-position="none">
							<el-carousel-item>
								<el-card shadow="never" class="box-card" v-if="cargoinfo.search_pic != ''" style="margin-top:1px;" :body-style="{ padding: '0px' }">
									<div slot="header" class="clearfix">
										<div class="headtitle"><i class="el-icon-delete Danger" title="删除" @click="delfile(0)"></i></div>
									</div>
									<div class="block divimage">
										<el-image :src="cargoinfo.search_pic.src">
											<div slot="error" class="image-slot el-image_icon"><i class="el-icon-picture-outline"></i></div>
										</el-image>
									</div>
								</el-card>
								<div class="block divimage" v-if="cargoinfo.search_pic == ''"><p>No picture</p></div>
							</el-carousel-item>
						</el-carousel>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form label-width="108px" size="mini">
							<el-form-item label="Extra pics">
								<el-upload
									class="avatar-uploader"
									action="#"
									:show-file-list="false"
									:on-change="BannerChange"
									accept="image/*"
									ref="banner_pic"
									:multiple="true"
									v-model="banner_piclist"
								>
									<i class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="10">
						<el-carousel arrow="nerver" height="215px" :autoplay="false" indicator-position="none">
							<el-carousel-item v-for="(item, index) in cargoinfo.banner_pic" :key="index">
								<el-card shadow="never" class="box-card" :body-style="{ padding: '0px' }">
									<div slot="header" class="clearfix">
										<div class="headtitle"><i class="el-icon-delete Danger" title="删除" @click="delbanner(item)"></i></div>
									</div>
									<div class="block divimage">
										<el-image :src="item.src">
											<div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
										</el-image>
									</div>
								</el-card>
							</el-carousel-item>
							<el-carousel-item v-if="cargoinfo.banner_pic.length == 0">
								<div class="block divimage"><p>No picture</p></div>
							</el-carousel-item>
						</el-carousel>
					</el-col>
				</el-row>
			</el-card>
		</div>
		<el-card class="box-card" v-show="active == 2" v-loading="describeloading">
			<div slot="header" class="clearfix"><span>Product description</span></div>
			<div id="editor" ref="editor" style="margin-top:-10px" class="diveditor"></div>
		</el-card>
		<el-row class="footerhandler" v-if="isshow">
			<el-col :span="active == 0 ? 8 : 5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn_cancel" v-if="active > 0"><div @click="pervstep">Last page</div></el-col>
			<el-col :span="4" class="submitBtn_orange" v-if="active < 2"><div @click="nextstep">Next page</div></el-col>
			<el-col :span="4" class="submitBtn" v-if="active == 2"><div @click="SaveCargo">Release product</div></el-col>
		</el-row>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
import E from 'wangeditor';
export default {
	components: {
		tableui
	},
	data() {
		let _self = this;
		return {
			divclass: 'cargoissue',
			loading: false,
			gridheight: '250px',
			windowHeight: window.innerHeight - 120,
			active: 0,
			cargoinfo: {
				p_sort: '',
				search_pic: '',
				cnameall: '',
				cname: '',
				brand: '',
				banner_pic: [],
				describe: '',
				id: '',
				lang:''
			},
			cargo_id: '', //修改时使用
			disabled: false,
			sortlist: [],
			props: {
				lazy: true,
				value: 'p_sort',
				label: 'p_sort',
				leaf: 'ischild',
				lazyLoad(node, resolve) {
					if (node.level > 0) {
						_self.loadSort(node.data.id, resolve);
					}
				}
			},
			result: '',
			searchpiclist: [],
			banner_piclist: [],
			speclist: [],
			spectablecol: [
				{
					field: 'price',
					title: 'Original price',
					type: 'input',
					width: '100',
					isfixed: 1
				},
				{
					field: 'outprice',
					title: 'Sales price',
					type: 'input',
					width: '100',
					isfixed: 1
				},
				{
					field: 'num',
					title: 'Stock',
					type: 'input',
					width: '100',
					isfixed: 1
				},
				{
					field: 'cno',
					title: 'Product code',
					type: 'input',
					width: '100',
					isfixed: 1
				},
				{
					field: 'barcode',
					title: 'EAN',
					type: 'input',
					width: '100',
					isfixed: 1
				}
			],
			specdatalist: [],
			selectedspec: [],
			newrow: { price: '', outprice: '', num: '', cno: '',barcode:'' },
			editor: {},
			brandlist: [],
			selectedsort:'',
			picloading:false,
			describeloading:false,
			cargoinfoloading:false,
			isshow:true,
			langlist:[],
			cargotype:''
		};
	},
	methods: {
		init(param) {
			this.$apipost.get.getTheme().then(res => {
				import('../../static/' + res + '/style/baseinfo/cargoissue.scss');
			});
			if (param.id != undefined) 
				//获取商品信息
				this.cargo_id=param.id;
			if(param.cargotype!=undefined)
				this.cargotype=param.cargotype;
			if(this.cargo_id!=''){
				this.GetCargoInfo();
				this.active=1;
			}
			this.GetLanglist();
		},
		changelang(val){
			this.loadSort(0);
		},
		//加载分类
		loadSort(pid, resolve) {
			var that = this;
			that.brandlist = [];
			that.speclist = [];
			that.specdatalist = [];
			var paraminfo={ p_id: pid,lang:this.cargoinfo.lang,isenabled:'1',cargotype:this.cargotype };
			this.$apipost.get.GetCargoSortList({paraminfo:paraminfo}).then(res => {
				//console.log('list',res.list);
				if (res.list != undefined) {
					if (resolve == undefined) {
						that.sortlist = res.list;
					} else {
						resolve(res.list);
					}
				}
			});
		},
		GetLanglist(){
			//debugger
			var that = this;
			this.$apipost.get.dic({ type: '语言类型' }).then(res => {
				//debugger
				if (res.list != undefined) {
					that.langlist=res.list;
					if(that.cargoinfo.lang=='')
						that.cargoinfo.lang=res.list[0].value;
					if(that.cargo_id=='')
						that.loadSort(0);
				}
			});
		},
		//下一步
		nextstep() {
			var that=this;
			if (this.active == 0) {
				var nodes = this.$refs.sortpanel.getCheckedNodes();
				if (nodes.length > 0) {
					if(nodes[0]!=null){
						if (nodes[0].data.haschild) {
							this.$tool.message('请选择最末级分类', 0);
							return false;
						}
						else{
							this.cargoinfo.p_sort=nodes[0].data.p_sort;
							this.selectedsort=nodes[0].pathLabels.join('->');
						}
					}else {
					this.$tool.message('请选择商品分类', 0);
					return false;
				}
				} else {
					this.$tool.message('请选择商品分类', 0);
					return false;
				}
				//debugger
				if (this.brandlist.length == 0) {
					this.loadCargoBrand(); //加载品牌
					//if(this.cargo_id=='')
					this.loadCargoSpec();
				}
			} else if (this.active == 1) {
				if (this.checkInfo()) {
					if (this.editor.config == undefined) {
						if(this.cargo_id=='')
							this.initEditor();
						else
							this.GetCargoDescribe();
					}
				} else return false;
			}
			if (this.active < 2) this.active = this.active + 1;
		},
		//上一步
		pervstep() {
			if(this.active==1){
				if(this.sortlist.length==0)
					this.loadSort(0);
			}
			this.active = this.active - 1;
		},
		//选择商品分类
		selectchange(val) {
			this.cargoinfo.p_sort = val[val.length - 1];
			this.selectedsort=val.join('->');
			this.brandlist=[];
		},
		//加载品牌
		loadCargoBrand() {
			var that = this;
			var paraminfo = {
				p_sort: this.cargoinfo.p_sort,
				cargotype:this.cargotype,
				lang:this.cargoinfo.lang
			};
			this.$apipost.get.GetCargoBrand_SC({ paraminfo: paraminfo }).then(res => {
				if (res.state == '1') {
					that.brandlist = res.list;
				}else
					that.brandlist=[];
					
			});
		},
		//加载规格
		loadCargoSpec() {
			var that = this;
			var paraminfo = {
				p_sort: this.cargoinfo.p_sort,
				cargotype:this.cargotype
			};
			this.$apipost.get.GetSpce_SC({ paraminfo: paraminfo }).then(res => {
				if (res.state == '1') {
					var speclist = [];
					res.list.forEach(e => {
						var objinfo = {
							spec_name: e.spec_name,
							spec: []
						};
						var spec = JSON.parse(e.spec);
						
						spec.forEach(b => {
							var obj = {
								selected: false,
								value: b.toString()
							};
							obj.selected=that.checkSpecChecked(e.spec_name,b.toString());
							if(obj.selected){
								var fields=that.spectablecol.filter(function(s){
									return s.title==e.spec_name;
								});
								if(fields.length>0){
									var selectedspec=that.selectedspec.filter(function(sp){
										return sp.title==e.spec_name;
									});
									if(selectedspec.length>0){
										that.selectedspec.forEach(se=>{
											if(se.title==e.spec_name){
												se.spec.push(b.toString());
												return false;
											}	
										});
									}else
										that.selectedspec.push({ title: e.spec_name, field:fields[0].field, spec:[b.toString()]});
								}
							}
							objinfo.spec.push(obj);
						});
						speclist.push(objinfo);
					});
					that.speclist = speclist;
				}
				else
					that.speclist=[];
			});
		},
		//检测规格是否要被选中
		checkSpecChecked(spec_name,spec){
			var that=this;
			var ischecked=false;
			if(that.cargo_id!=''){
				if(that.specdatalist.length>0){
					var issearched=false;
					that.specdatalist.forEach(e=>{
						e.specjson.forEach(s=>{
							for(var i in s){
								if(s[i]==spec_name&&s.value==spec){
									ischecked=true;
									issearched=true;
									break;
								}
							}
							if (issearched)
								return false;
						});
						if (issearched)
							return false;
					});
				}
			}
			return ischecked;
		},
		//本地预览图片
		getLocalImg(file, type) {
			// 获取上传图片的本地url，用于上传前的本地预览
			//debugger
			var postfix = file.name.substring(file.name.lastIndexOf('.'), file.name.length);
			var that = this;
			let reader = new FileReader();
			reader.readAsDataURL(file.raw);
			reader.onload = () => {
				if (type == 1) that.cargoinfo.search_pic = { src: reader.result, postfix: postfix };
				else 
				{
					var list=that.cargoinfo.banner_pic.filter(function(b) {
						return b.name == file.name;
					});
					if(list.length==0)
						that.cargoinfo.banner_pic.push({name:file.name,src: reader.result, postfix: postfix });
				}
			};
		},
		//上传附件改变时
		searchPicChange(file, fileList) {
			var that = this;
			if (fileList.length > 0) {
				var list = [];
				fileList.forEach(e => {
					const isLt20M = e.size / 1024 / 1024 < 1;
					if (!isLt20M) {
						this.$tool.message(e.name + '已超过1M,不允许上传', 0);
						this.$refs.upload.abort(e);
					} else {
						var list=that.searchpiclist.filter(function(b) {
							return b.name == e.name;
						});
						if(list.length==0){
							that.searchpiclist.push(e);
							that.getLocalImg(e, 1);
						}	
					}
				});
			}
		},
		//移除上传的文件
		delfile(index) {
			//debugger;
			if(this.searchpiclist[index]!=undefined){
				this.$refs.upload.abort(this.searchpiclist[index]);
				this.searchpiclist.splice(index, 1);
			}
			this.cargoinfo.search_pic = '';
		},
		//上传轮播图
		BannerChange(file, fileList) {
			var that = this;
			if (fileList.length > 0) {
				fileList.forEach(e => {
					const isLt20M = e.size / 1024 / 1024 < 1;
					if (!isLt20M) {
						this.$tool.message(e.name + '已超过1M,不允许上传', 0);
						this.$refs.banner_pic.abort(e);
					} else {
						var list=that.banner_piclist.filter(function(b) {
							return b.name == e.name;
						});
						if(list.length==0){
							that.banner_piclist.push(e);
						}
						
					}
				});
				that.getLocalImg(file, 2);
			}
		},
		//删除轮播图
		delbanner(index) {
			//debugger;
			if(this.banner_piclist[index]!=undefined){
				this.$refs.banner_pic.abort(this.banner_piclist[index]);
				this.banner_piclist.splice(index, 1);
			}
			var list=[];
			this.cargoinfo.banner_pic.splice(index, 1);
			if(this.cargoinfo.banner_pic.length==0)
				this.banner_piclist=[];
		},
		//选择规格值
		Specselect(index, i) {
			var that = this;
			var selected = !this.speclist[index].spec[i].selected;
			this.speclist[index].spec[i].selected = selected;
			var name = this.speclist[index].spec_name;

			var field = 'spec' + (this.spectablecol.length + 1);
			var isexsts = this.selectedspec.filter(function(e) {
				return e.title == name;
			});
			var colisexsts = this.spectablecol.filter(function(e) {
				return e.title == name;
			});
			//生成列表
			//debugger;
			if (selected) {
				//表示要新增
				//debugger
				if (colisexsts.length == 0) {
					this.spectablecol.splice(this.spectablecol.length - 5, 0, {
						field: field,
						title: this.speclist[index].spec_name,
						type: 'text',
						width: '100',
						isfixed: 0
					});
				}
				if (isexsts.length > 0) {
					this.selectedspec.forEach(e => {
						if (e.title == name) {
							e.spec.push(that.speclist[index].spec[i].value);
							return false;
						}
					});
				} else this.selectedspec.push({ title: name, field: field, spec: [that.speclist[index].spec[i].value] });
			} else {
				if(this.speclist.length==1){
					for (var ix = 0; ix < this.selectedspec.length; ix++) {
						if (this.selectedspec[ix].title == name) {
							var speclist = this.selectedspec[ix].spec;
							for (var j = 0; j < speclist.length; j++) {
								if (speclist[j] == this.speclist[index].spec[i].value) {
									this.selectedspec[ix].spec.splice(j, 1);
									break;
								}
							}
							if (this.selectedspec[ix].spec.length == 0) this.selectedspec.splice(ix, 1);
						}
					}
				}
				else{
					for (var idx = 0; idx < this.spectablecol.length; idx++) {
						if (this.spectablecol[idx].title == name) {
							this.spectablecol.splice(idx, 1);
							for (var ix = 0; ix < this.selectedspec.length; ix++) {
								if (this.selectedspec[ix].title == name) {
									var speclist = this.selectedspec[ix].spec;
									for (var j = 0; j < speclist.length; j++) {
										if (speclist[j] == this.speclist[index].spec[i].value) {
											this.selectedspec[ix].spec.splice(j, 1);
											break;
										}
									}
									if (this.selectedspec[ix].spec.length == 0) this.selectedspec.splice(ix, 1);
								}
							}
							break;
						}
					}
				}

			}
			this.createspeclist();
		},
		//构建规格表结构
		createspeclist() {
			//生成行
			var that = this;
			var rowcompose = [];
			var col = this.spectablecol.filter(function(e) {
				return e.isfixed == 0;
			});
			col.forEach(e => {
				that.newrow[e.field] = '';
			});
			that.specdatalist = [];
			if (this.selectedspec.length == 1) {
				this.selectedspec.forEach(e => {
					e.spec.forEach(s => {
						var newrow = JSON.parse(JSON.stringify(that.newrow));
						newrow[e.field] = s.toString();
						that.specdatalist.push(newrow);
					});
				});
			} else if(this.selectedspec.length>1) {
				var newrow = JSON.parse(JSON.stringify(that.newrow));
				var array = [];
				this.selectedspec[0].spec.forEach(e => {
					var obj = JSON.parse(JSON.stringify(newrow));
					obj[that.selectedspec[0].field] = e.toString();
					array.push(obj);
				});
				that.specdatalist = this.createrow(1, array);
			}else{
				this.spectablecol.splice(0, 1);
			}
		},
		//生成规格列表
		createrow(endi, array) {
			var that = this;
			var newrow = JSON.parse(JSON.stringify(that.newrow));
			var newarray = JSON.parse(JSON.stringify(array));
			for (var i = 0; i < array.length; i++) {
				that.selectedspec[endi].spec.forEach(b => {
					var isexists = false;
					for (var k in newarray[i]) {
						if (k == that.selectedspec[endi].field && newarray[i][k] != '') {
							isexists = true;
							break;
						}
					}
					if (isexists) {
						var obj = JSON.parse(JSON.stringify(newrow));
						for (var k in newarray[i]) {
							obj[k] = newarray[i][k].toString();
						}
						obj[that.selectedspec[endi].field] = b.toString();
						newarray.push(obj);
					} else {
						newarray[i][that.selectedspec[endi].field] = b.toString();
					}
				});
			}
			if (endi + 1 < that.selectedspec.length) array = that.createrow(endi + 1, newarray);
			else array = newarray;
			return array;
		},
		//初始化富文本框内容
		initEditor(html) {
			this.editor = new E(this.$refs.editor);
			this.editor.config.height = window.innerHeight - 360;
			this.editor.config.uploadImgShowBase64 = true;
			this.editor.config.uploadImgMaxSize = 1 * 1024 * 1024;
			this.editor.config.excludeMenus = ['emoticon', 'video', 'undo', 'redo', 'todo'];
			this.editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
			this.editor.config.uploadFileName = 'fileupload';
			this.editor.config.showLinkImg = false;
			this.editor.config.placeholder = '请输入商品描述';
			this.editor.create();
			if(html!=undefined)
				this.editor.txt.html(html);
		},
		//检测商品必填信息
		checkInfo() {
			var isgo = true;
			if (this.active == 1) {
				if (this.cargoinfo.lang.replace(/ /g, '') == '') {
					this.$tool.message('请选择语言类型', 0);
					isgo = false;
				}
				//保存基本信息
				if(isgo){
					if (this.cargoinfo.pkcno.replace(/ /g, '') == '') {
						this.$tool.message('请填写商品ID', 0);
						isgo = false;
					}
				}
				if(isgo){
					if (this.cargoinfo.cname.replace(/ /g, '') == '') {
						this.$tool.message('请填写商品名称', 0);
						isgo = false;
					}
				}
				if (isgo) {
					if (this.cargoinfo.brand.replace(/ /g, '') == '') {
						this.$tool.message('请选择商品品牌', 0);
						isgo = false;
					}
				}
				if (isgo) {
					if (this.specdatalist.length == 0) {
						this.$tool.message('请填写规格', 0);
						isgo = false;
					}else{
						isgo=this.CheckSpeclist();
					}
				}
				if (isgo) {
					if (this.cargoinfo.search_pic == '') {
						this.$tool.message('请上传商品图片', 0);
						isgo = false;
					}
				}
				if (isgo) {
					if (this.cargoinfo.banner_pic.length == 0) {
						this.$tool.message('请上传商品轮播图', 0);
						isgo = false;
					}
				}
			}
			if (this.active == 2) {
				this.cargoinfo.describe = this.editor.txt.html();
				if (this.cargoinfo.describe == '') {
					this.$tool.message('请填写商品描述', 0);
					isgo = false;
				}
			}
			return isgo;
		},
		CheckSpeclist(){
			var isgo = true;
			for(var i=0;i<this.specdatalist.length;i++){
				if(this.specdatalist[i].price==''){
					this.$tool.message('请填写第'+(i+1)+'行的原价', 0);
					isgo = false;
					break;
				}
				else{
					if(isNaN(Number(this.specdatalist[i].price.replace('.',''))))
					{
						this.$tool.message('第'+(i+1)+'行的原价请填写数字', 0);
						isgo = false;
						break;
					}
				}
				if(this.specdatalist[i].outprice==''){
					this.$tool.message('请填写第'+(i+1)+'行的销售价', 0);
					isgo = false;
					break;
				}
				else{
					if(isNaN(Number(this.specdatalist[i].outprice.replace('.',''))))
					{
						this.$tool.message('第'+(i+1)+'行的销售价请填写数字', 0);
						isgo = false;
						break;
					}
				}
				if(this.specdatalist[i].num==''){
					this.$tool.message('请填写第'+(i+1)+'行的库存', 0);
					isgo = false;
					break;
				}
				else{
					if(isNaN(Number(this.specdatalist[i].num)))
					{
						this.$tool.message('第'+(i+1)+'行的库存请填写数字', 0);
						isgo = false;
						break;
					}
				}
				if(this.specdatalist[i].cno==''){
					this.$tool.message('请填写第'+(i+1)+'行的商品编号', 0);
					isgo = false;
					break;
				}
			}
			return isgo;
		},
		//保存商品
		SaveCargo() {
			var that = this;
			var paraminfo = {};
			if (this.checkInfo()) {
				//保存基本信息
				paraminfo = {
					lang:this.cargoinfo.lang,
					cname: this.cargoinfo.cname,
					brand: this.cargoinfo.brand,
					p_sort: this.cargoinfo.p_sort,
					cnameall: this.cargoinfo.cnameall,
					id: this.cargo_id,
					userid: localStorage.getItem('userid'),
					speccol: this.spectablecol,
					speclist: this.specdatalist,
					cargotype:this.cargotype,
					pkcno:this.cargoinfo.pkcno
				};
				 this.$message({
				          message: '正在保存',
				          center: true,
						  duration:0,
						  type:'warning',
						  offset: (window.innerHeight * 50) / 100
				        });
				
				//console.log('paraminfo',encodeURIComponent(JSON.stringify(paraminfo)));
				//return false;
				//debugger
				this.isshow=false;
				this.$apipost.post.SaveCargo_SC({ paraminfo: paraminfo }).then(res => {
					if (res.state == '1') {
						that.cargoinfo.id = res.id;
						that.SavePic();
					} else {
						that.isshow=true;
						that.$message.closeAll();
						this.$tool.message(res.message, 0);
					}
				});
			}
		},
		//保存图片/轮播图
		SavePic() {
			var that = this;
			var paraminfo = {
				search_pic: this.cargoinfo.search_pic,
				banner_pic: this.cargoinfo.banner_pic,
				cargotype:this.cargotype
			};
			this.$apipost.post.SaveCargoPic({ paraminfo: paraminfo, cargo_id: that.cargoinfo.id }).then(res => {
				if (res.state == '1') {
					that.SaveDescribe();
				} else {
					that.isshow=true;
					that.$message.closeAll();
					this.$tool.message(res.message, 0);
				}
			});
		},
		//保存商品描述
		SaveDescribe() {
			var that = this;
			this.$apipost.post.SaveCargoDescribe({ describe: this.cargoinfo.describe,cargo_id: that.cargoinfo.id,cargotype:this.cargotype }).then(res => {
				that.isshow=true;
				that.$message.closeAll();
				if (res.state == '1') {
					this.$tool.message('发布成功', 1);
					setTimeout(function() {
						Utils.$emit('handleRermove', localStorage.getItem('tabname'));
					}, 1000);
				} else {
					this.$tool.message(res.message, 0);
				}
			});
		},
		//获取商品信息
		GetCargoInfo(){
			var that=this;
			if(that.cargo_id!=''){
				this.cargoinfoloading=true;
				var paraminfo={cargo_id: that.cargo_id,pkcno:'',lang:'',
				cargotype:this.cargotype};
				//this.$tool.loading('正在加载',this.divclass);
				this.$apipost.get.GetCargoInfo_SC({paraminfo:paraminfo}).then(res => {
					this.cargoinfoloading=false;
					//this.$tool.loadingclose();
					if(res.state=='1'){
						var resinfo=JSON.parse(JSON.stringify(res.info));
						that.selectedsort=resinfo.parentsort;
						resinfo.search_pic='';
						resinfo.banner_pic=[];
						that.cargoinfo=resinfo;
						that.GetCargoPic();
						//设置规格回显
						that.SetSpecList(res);
					}
				});
			}
		},
		//加载图片
		GetCargoPic(){
			var that=this;
			if(that.cargo_id!=''){
				//this.$tool.loading('正在读取图片','cargoinfo');
				this.picloading=true;
				this.$apipost.get.GetCargoPic({cargo_id: that.cargo_id,
				cargotype:this.cargotype }).then(res => {
					this.picloading=false;
					//this.$tool.loadingclose();
					if(res.state=='1'){
						if(res.banner_pic!=undefined)
							that.cargoinfo.banner_pic=res.banner_pic;
						if(res.search_pic!=undefined)
							that.cargoinfo.search_pic=res.search_pic;
					}
				});
			}
		},
		//获取商品描述内容
		GetCargoDescribe(){
			var that=this;
			if(that.cargo_id!=''){
				this.describeloading=true;
				this.$apipost.get.GetCargoDescribe({cargo_id: that.cargo_id,cargotype:this.cargotype,isedit:1}).then(res => {
					this.describeloading=false;
					if(res.state=='1'){
						that.initEditor(res.describe);
					}else{
						that.initEditor();
					}
				});
			}
		},
		//设置规格显示
		SetSpecList(res){
			var that=this;
			if(res.speccol!=undefined){
				this.spectablecol=res.speccol.concat(this.spectablecol);
			}
			if(res.speclist!=undefined)
				this.specdatalist=res.speclist;
			//设置选中
			this.loadCargoSpec();
		}
	}
};
</script>

<style></style>
